'use client'

import dynamic from 'next/dynamic'

import { Loading } from '../../../../../loading'

/** Defers client-only, cart-dependent content until the drawer renders. */
export const DynamicProductPrescriptionDrawerContent = dynamic(
  async () =>
    import('../ProductPrescriptionDrawerContent').then(
      (module) => module.ProductPrescriptionDrawerContent,
    ),
  {
    loading: () => <Loading />,
    ssr: false,
  },
)
